
import getPublicAssets from "../../../../Services/s3bucket";

export const ConversationMenuOptions = [
  {
    avatar: getPublicAssets("images/agent.svg"),
    name: "All",
    id: "all",
    url: "#",
    isAvailable: true,
  },
  {
    avatar: getPublicAssets("images/unattended-live.svg"),
    name: "Unattended",
    id: "unattended",
    url: "#",
    isAvailable: true,
  },
];
// export const getChannelAvatar = (channel?: string) => {
//   if (channel === "messenger") {
//     return <Facebook />;
//   } else if (channel === "whatsapp") {
//     return <Whatsapp />;
//   } else if (channel === "telegram") {
//     return <Telegram />;
//   } else {
//     return <ChannelBot />;
//   }
// };

// export const ChannelsMenuOptions = [
//   {
//     avatar: Whatsapp,
//     name: "WhatsApp",
//     // id: uniqid(),
//     url: "#",
//     isAvailable: true,
//     agentRoute: true,
//   },
//   {
//     avatar: Facebook,
//     name: "Facebook",
//     // id: uniqid(),
//     url: "#",
//     isAvailable: true,
//     agentRoute: true,
//   },
// ];

export const LabelsMenuOptions = [
  {
    avatar: "",
    name: "All",
    // id: uniqid(),
    url: "#",
    isAvailable: true,
    agentRoute: true,
  },
  {
    avatar: "",
    name: "Marketing",
    // id: uniqid(),
    url: "#",
    isAvailable: true,
    agentRoute: true,
  },
  {
    avatar: "",
    name: "Product",
    // id: uniqid(),
    url: "#",
    isAvailable: true,
    agentRoute: true,
  },
];
